import { render } from "./AppPage.vue?vue&type=template&id=236a8790&ts=true"
import script from "./AppPage.vue?vue&type=script&lang=ts"
export * from "./AppPage.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__